import { SpotlightKey } from '@reach/interfaces/spotlights/spotlights.enum';

export const VALID_ONBOARDING_KEYS = Object.values(SpotlightKey) as SpotlightKey[];
